export class ScatterPlotSamplePoint {
    constructor(name: string, description: string, usefulnessLevel: number, commitmentLevel: number, domainName: string){
        this.Name = name; // Tooltip.
        this.Description = description;
        this.UsefulnessLevel = usefulnessLevel;  // X variable.
        this.CommittmentLevel = commitmentLevel; // Y Variable.
        this.DomainName = domainName; // FIlter Point.
    }

    public Name: string;
    public Description: string;
    public UsefulnessLevel: number;
    public CommittmentLevel: number;
    public DomainName: string;
}
